import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import {
  QueryParamsUpdates,
  QueryParamsUpdateType,
  UseDishFirstExploreUrl,
} from 'src/pages/consumer/explore/useExploreUrl';
import { DietaryVegan, DietaryVegetarian } from 'src/shared/design-system/Icon';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { Filters } from './Filters';
import { getProteinCategoriesToDisplay } from './ProteinFilters';

const dietaryCategories = [
  {
    tag: DietaryTags.VEGAN,
    icon: <DietaryVegan />,
    label: 'Vegan',
  },
  {
    tag: DietaryTags.VEGETARIAN,
    icon: <DietaryVegetarian />,
    label: 'Vegetarian',
  },
] as const;

function getDietaryCategoriesToDisplay() {
  return [
    ...dietaryCategories.map((c) => ({
      ...c,
      queryParam: QueryParams.DIETARY_FILTER,
    })),
  ];
}

interface BrowseByTagsFilterProps {
  filters: UseDishFirstExploreUrl;
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
}

export const AllPreferencesFilters: React.FC<BrowseByTagsFilterProps> = ({ filters, updateQueryParams }) => {
  const categories = [...getDietaryCategoriesToDisplay(), ...getProteinCategoriesToDisplay()];
  return (
    <Filters
      filterTitle='Browse by preference'
      filters={filters}
      updateQueryParams={updateQueryParams}
      categories={categories}
    />
  );
};
